import React from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeaderFooterLayout from '../components/layout/HeaderFooterLayout';

function PrivacyPolicy() {
  const { t } = useTranslation(['account']);

  return (
    <div className="login-page">
      <HeaderFooterLayout>
        <div className="privacy-policy-page">
          <h1>Politique de confidentialité</h1>
          <p>
            La présente Politique de confidentialité explique comment nous
            collectons, utilisons, partageons et protègeons les informations
            personnelles que vous nous fournissez lorsque vous utilisez notre
            site web www.openfleet.com (ci-après dénommé le « Site »). Votre vie
            privée est importante pour nous, et nous nous engageons à protéger
            et à respecter vos données personnelles. Veuillez lire attentivement
            cette politique pour comprendre comment nous traitons vos
            informations.
          </p>
          <p>
            Le Site a pour objet de fournir des informations sur notre
            technologie d’autopartage, de publier des articles de blogs et des
            contenus informatifs.
          </p>
          <ol>
            <li>Collecte d’informations</li>
          </ol>
          <ul>
            <li>
              Informations personnelles identifiables : Lorsque vous visitez
              notre Site, nous pouvons recueillir des informations personnelles
              identifiables telles que votre nom, votre adresse e-mail, votre
              numéro de téléphone, votre entreprise ou toute autre information
              que vous choisissez de nous fournir.
            </li>
          </ul>
          <ul>
            <li>
              Données de navigation : Nous collectons automatiquement certaines
              informations non personnelles lorsque vous naviguez sur notre
              Site, telles que votre adresse IP, votre type de navigateur, votre
              système d’exploitation, les pages que vous consultez et les liens
              sur lesquels vous cliquez.
            </li>
          </ul>
          <p>
            Ces données sont conservées pour une période maximale de 24 mois, et
            peuvent être utiliser pour vous informer des mises à jour ou
            d’évènements. Au bout de cette période, ces données seront
            supprimées de notre base de données.
          </p>
          <ol start="2">
            <li>Utilisation des informations</li>
          </ol>
          <p>
            2.1 Nous utilisons les informations collectées pour vous fournir les
            services et les fonctionnalités de notre Site, pour répondre à vos
            demandes, pour améliorer notre Site et pour vous informer des mises
            à jour et des offres spéciales.
          </p>
          <p>
            2.2 Nous pouvons utiliser vos informations pour vous contacter à des
            fins de marketing et de promotion, à moins que vous ne vous y
            opposiez.
          </p>
          <ol start="3">
            <li>Partage des informations</li>
          </ol>
          <p>
            3.1 Nous ne vendons, ne louons ni ne partageons vos informations
            personnelles identifiables avec des tiers, sauf dans les cas
            suivants :
          </p>
          <ul>
            <li>
              Lorsque vous nous donnez votre consentement explicite pour
              partager vos informations ;
            </li>
            <li>
              Lorsque nous devons partager vos informations avec nos
              prestataires de services tiers afin de vous fournir les services
              demandés ;
            </li>
            <li>
              Lorsque la loi l’exige ou lorsque nous estimons de bonne foi que
              la divulgation est nécessaire pour protéger nos droits, notre
              propriété ou notre sécurité, ou pour se conformer à une procédure
              judiciaire en cours, à une décision de justice ou à une demande
              gouvernementale.
            </li>
          </ul>
          <ol start="4">
            <li>Sécurité des informations</li>
          </ol>
          <p>
            4.1 Nous prenons des mesures techniques et organisationnelles
            appropriées pour protéger les informations personnelles que vous
            nous fournissez contre toute perte, utilisation abusive, accès non
            autorisé, divulgation, altération ou destruction.
          </p>
          <ol start="5">
            <li>Vos choix</li>
          </ol>
          <p>
            5.1 Vous pouvez choisir de ne pas nous fournir certaines
            informations personnelles, mais cela peut limiter votre accès à
            certaines fonctionnalités du Site.
          </p>
          <p>
            5.2 Si vous ne souhaitez pas recevoir de communications marketing de
            notre part, vous pouvez vous désabonner en envoyant un mail à{' '}
            <a href="mailto:contact@openfleet.com">contact@openfleet.com</a>
          </p>
          <ol start="6">
            <li>Liens vers des sites tiers</li>
          </ol>
          <p>
            6.1 Notre Site peut contenir des liens vers des sites web de tiers.
            Cette Politique de confidentialité ne s’applique pas aux pratiques
            de confidentialité de ces sites web. Nous vous encourageons à lire
            les politiques de confidentialité de ces sites web avant de leur
            fournir vos informations personnelles.
          </p>
          <ol start="7">
            <li>Modifications de la politique de confidentialité</li>
          </ol>
          <p>
            7.1 Nous nous réservons le droit de modifier cette Politique de
            confidentialité à tout moment. Toute modification entrera en vigueur
            dès sa publication sur notre Site. Nous vous encourageons à
            consulter régulièrement cette page pour prendre connaissance des
            éventuelles modifications.
          </p>
          <p>
            Si vous avez des questions ou des préoccupations concernant cette
            Politique de confidentialité, veuillez nous contacter à l’adresse
            suivante : contact@openfleet.com
          </p>
          <p>Merci d’avoir lu notre Politique de confidentialité.</p>
        </div>
      </HeaderFooterLayout>
    </div>
  );
}

export default withRouter(PrivacyPolicy);
